import About from '@/components/about/About';
import React from 'react';

export default function _About() {
  return <About />;
}
